import React from 'react';
import { MapStateProvider } from './map/Provider';

export const ApplicationStateProvider = ({ children }) => {
  return <MapStateProvider>{children}</MapStateProvider>;
};
